var ctx = (function () {

    function Ctx() {
        return {
            os: this.match(navigator.userAgent, this.os),
            app: this.match(navigator.appVersion, this.app),
            isMobile: function () {
                return this.os.name !== 'unknown';
            },
            inApp: function () {
                return this.app.name !== 'unknown';
            }
        };
    }
  
    Ctx.prototype = {
        os: [
            {name: 'iOS', regex: /iP(hone|od|ad)/, verRegex: /OS (\d+)_(\d+)(?:_(\d+))?/},
            {name: 'Android', regex: /Android/, verRegex: /Android (\d+)(?:\.(\d+))?(?:\.(\d+))?/}
        ],
        app: [
            {name: 'QQ', regex: /QQ\//, verRegex: /QQ\/(\d+)\.(\d+)(?:\.(\d+))?/},
            {name: 'WeChat', regex: /MicroMessenger/, verRegex: /MicroMessenger\/(\d+)\.(\d+)(?:\.(\d+))?/},
            {name: 'Weibo', regex: /Weibo/, verRegex: /Weibo \(.*_(\d+)\.(\d+)(?:\.(\d+))?_.*\)?/}
        ],
        match: function (string, data) {
            for (var i = 0; i < data.length; i += 1) {
                if (data[i].regex.test(string)) {
                    var v = string.match(data[i].verRegex);
                    return {
                        name: data[i].name,
                        version: parseInt(v[1], 10),
                        info: parseInt(v[1], 10) + '.' + parseInt(v[2] || 0, 10) + '.' + parseInt(v[3] || 0, 10)
                    };
                }
            }
  
            return {name: 'unknown', version: 0, info: ''};
        }
    };
  
    return new Ctx();
  })();
  
  export function openApp(scheme) {
    if (scheme) {
        var appLink = "https://new-share.med-video.com/h5?scheme=" + encodeURI(scheme);
    } else {
        var appLink = "https://new-share.med-video.com/h5";
        scheme = 'yspjsyl://';
    }
  
    if (ctx.isMobile() && !ctx.inApp()) {
        window.location.href = scheme;
  
        setTimeout(function () {
            window.location.href = appLink;
        }, 250);
  
        setTimeout(function () {
            window.location.reload();
        }, 1000);
    } else {
        window.location.href = appLink;
    }
  }
  


// WEBPACK FOOTER //
// ./src/utils/skipapp.js